export const GET_ALL_COMPLAIN_START = "GET_ALL_COMPLAIN_START";
export const GET_ALL_COMPLAIN_SUCCESS = "GET_ALL_COMPLAIN_SUCCESS";
export const GET_ALL_COMPLAIN_FAILURE = "GET_ALL_COMPLAIN_FAILURE";



